import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Card, CardText, CardBody, CardTitle, Button, Col, Row } from 'reactstrap';
import { SlBranchDisplay, SlSectionTitle, SlSectionLabel, SlPageTitle, SlFormEntryRow, ReadOnlyField, SlEditorButton, SlButton, SlCheckBox, SlBusyIndicator, SlMoneyInput, SLDetailsTable } from '../editors'
import Stepper from "./Stepper";
import { connect } from "react-redux";
import { metadataService, newLoanStepperService, workflowService, userService, SessionService, newLoanService, ServiceUtil } from "../../_services"
import validator from 'validator';

import { financialInfoActions, newLoanActions, refinanceIncreaseLoanActions } from "../../_actions";
import { newLoanConstants, workflowConstants } from '../../_constants';
import { history } from "../../_helpers";
import { ConfirmationView } from "./ConfirmationView";
import { FinancialDetails } from './FinancialDetails';
import pencil from '../images/SL-pencil.svg';

class ConfirmationSummary extends Component {
    static displayName = ConfirmationSummary.name;

    constructor(props) {
        super(props);

        this.state = {
            firstName: "",
            lastName: "",
            address: "",
            address2: "",
            city: "",
            zipCode: "",
            userState: "",
            email: "",
            rentOrOwn: "",
            yearsInHome: "",
            monthsInHome: "",
            monthlyResidencePayment: "",
            mobileNumber: "",
            alternateMobileNumber: "",
            dateOfBirth: "",
            requestedAmount: "",
            primaryIncome: "",
            employer: "",
            yearsAtEmployer: "",
            monthsAtEmployer: "",
            workNumber: "",
            employerCity: "",
            employerPostalCode: "",
            employerState: "",
            employerStreetAddress: "",
            employerStreetAddress2: "",
            incomePerPeriod: "",
            payFrequency: "",
            otherIncomeSource: "",
            verifyOffers: false,
            verifyConsentState: false,
            bankAccountNumber: this.props.bankAccountNumber,
            bankRoutingNumber: this.props.bankRoutingNumber,
            isInvalid: true,
            sunLoanBranch: "",
            isWorking: false,
            steps: [],
            currentStep: '',
            canMoveBack: false,
            canMoveForward: true,
            workflowId: null,
            currentUser: {},
            refinanceComplete: false,
            submitting: false,
            isEditingRequesedAmount: false,
            tempRequestedAmount: "",
            hideEditButtons: false,
            verifyContact: true,
            marketingCookies: this.props.marketingCookies,
            isAmountValid: true,
            errorMessages: []
        };

        this.handleNavigationToPersonalDataScreen = this.handleNavigationToPersonalDataScreen.bind(this);
        this.handleNavigationToIDScreen = this.handleNavigationToIDScreen.bind(this);
        this.handleNavigationToPasswordScreen = this.handleNavigationToPasswordScreen.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCheckChange = this.handleCheckChange.bind(this);
        this.handleChangeState = this.handleChangeState.bind(this);
        this.handleEditRequestedAmount = this.handleEditRequestedAmount.bind(this);
        this.handleEditRequestAmountCancel = this.handleEditRequestAmountCancel.bind(this);
        this.onDone = this.onDone.bind(this);
        this.isValidAmount = this.isValidAmount.bind(this);
    }

    async componentDidMount() {

        var requestSubmitted = JSON.parse(sessionStorage.getItem("requestSubmitted"));
        if (requestSubmitted && requestSubmitted.RequestAlreadySubmitted) {
            var currentUser = userService.getCurrentUser();
            if (currentUser) {
                history.push("/my-account");
            }
            else {
                history.push("/LogInMain");
            }
        }

        let newState = {
            ...this.state,
            SMSUrl: await ServiceUtil.getServiceUrl("SMSUrl"),
            SMSUrlSpanish: await ServiceUtil.getServiceUrl("SMSUrlEs"),
        };

        let workflowData = workflowService.getCurrentWorkflowStepData();

        this.handleChangeState(newState);
        let registrationPersonalInfo = SessionService.getPersonalInfo();
        let fundingInfo = SessionService.getFundingInformation();
        if (!fundingInfo) {
            fundingInfo = {
                FundDelivery: metadataService.fundDeliveryType.InStore,
                BranchId: registrationPersonalInfo.branchId,
            }
            SessionService.setFundingInformation(fundingInfo)
        }

        if (registrationPersonalInfo && fundingInfo) {
            this.props.actions.loadFinancialsFromSession();
            let newState = {
                firstName: registrationPersonalInfo.firstName,
                lastName: registrationPersonalInfo.lastName,
                address1: registrationPersonalInfo.address1,
                city: registrationPersonalInfo.city,
                postalCode: registrationPersonalInfo.postalCode,
                state: registrationPersonalInfo.state,
                email: registrationPersonalInfo.email,
                residenceType: registrationPersonalInfo.residenceType,
                monthlyResidencePayment: registrationPersonalInfo.monthlyResidencePayment,
                years: registrationPersonalInfo.years,
                months: registrationPersonalInfo.months,
                mobileNumber: registrationPersonalInfo.mobileNumber,
                alternateMobileNumber: registrationPersonalInfo.alternateMobileNumber,
                requestedAmount: registrationPersonalInfo.requestedAmount,
                fundDelivery: fundingInfo.FundDelivery,
                bankAccountNumber: fundingInfo.BankAccountNumber,
                bankRoutingNumber: fundingInfo.BankRoutingNumber,
                workflowId: workflowData.workflowId,
            };

            if (workflowData &&
                (workflowData.workflowId === workflowConstants.REFINANCE_INCREASE_LOAN_WORKFLOW
                    || workflowData.workflowId === workflowConstants.REFINANCE_INCREASE_LOAN_DISABLED_FUNDING_WORKFLOW)) {
                let changeLoanRequest = JSON.parse(sessionStorage.getItem("changeLoanRequest"));

                if (workflowData.workflowId === workflowConstants.REFINANCE_INCREASE_LOAN_WORKFLOW && changeLoanRequest.branchId) {
                    this.setState({ isWorking: true });
                    metadataService.getBranch(changeLoanRequest.branchId)
                        .then(response => {
                            this.setState({ ...newState, isWorking: false, sunLoanBranch: response.data });
                        });
                }
                if (workflowData.workflowId === workflowConstants.REFINANCE_INCREASE_LOAN_DISABLED_FUNDING_WORKFLOW && fundingInfo.BranchId) {
                    this.setState({ isWorking: true });

                    metadataService.getBranch(fundingInfo.BranchId)
                        .then(response => {
                            this.setState({ ...newState, isWorking: false, sunLoanBranch: response.data });
                        });
                }
                let currentUser = {};
                if (workflowData.workflowId === workflowConstants.REFINANCE_INCREASE_LOAN_WORKFLOW
                    || workflowData.workflowId === workflowConstants.REFINANCE_INCREASE_LOAN_DISABLED_FUNDING_WORKFLOW) {
                    currentUser = userService.getCurrentUser();
                }
                newState.refinanceComplete = changeLoanRequest.refinanceComplete;
                newState.workflowId = workflowData.workflowId;
                newState.steps = newLoanStepperService(workflowData.workflowId);
                newState.currentStep = workflowData.currentStepperStep + 1;
                newState.canMoveBack = workflowData.canMoveBack;
                newState.canMoveForward = workflowData.canMoveForward;
                newState.currentUser = currentUser;
                newState.email = currentUser.claims.email;
                newState.requestedAmount = changeLoanRequest.requestedAmount;
                this.setState(newState);
            }

            if (fundingInfo.FundDelivery === metadataService.fundDeliveryType.InStore) {
                if (fundingInfo.BranchId) {
                    this.setState({ isWorking: true });
                    metadataService.getBranch(fundingInfo.BranchId)
                        .then(response => {
                            this.setState({ ...newState, isWorking: false, sunLoanBranch: response.data });
                        });
                } else {
                    this.setState(newState);
                }
            }
            else {
                newState.sunLoanBranch = fundingInfo.BranchId;
                this.setState(newState);
            }
            await this.updateLoanAmounts(newState.state);
            this.validateForSubmit();
        } else {
            // this.props.actions.unexpectedError();
        }
    }
    async componentDidUpdate(prevProps, prevState, snapshot) {
        let fundingInfo = SessionService.getFundingInformation();

        let newState = {
            ...this.state
        };
        if (JSON.stringify(prevState) !== JSON.stringify(this.state)) {
            this.validateForSubmit();
        }
        let workflowData = workflowService.getCurrentWorkflowStepData();
        if (workflowData.workflowId === workflowConstants.REFINANCE_INCREASE_LOAN_WORKFLOW
            || workflowData.workflowId === workflowConstants.REFINANCE_INCREASE_LOAN_DISABLED_FUNDING_WORKFLOW) {
            if (prevProps.refinanceLoading !== this.props.refinanceLoading) {
                let changeLoanRequest = JSON.parse(sessionStorage.getItem("changeLoanRequest"));
                if (changeLoanRequest.branchId) {
                    this.setState({ isWorking: true });
                    metadataService.getBranch(changeLoanRequest.branchId)
                        .then(response => {
                            this.setState({ ...newState, isWorking: false, sunLoanBranch: response.data });
                        });
                }
                let currentUser = {};
                if (workflowData.workflowId === workflowConstants.REFINANCE_INCREASE_LOAN_WORKFLOW || workflowData.workflowId === workflowConstants.REFINANCE_INCREASE_LOAN_DISABLED_FUNDING_WORKFLOW) {
                    currentUser = userService.getCurrentUser();
                }
                newState.workflowId = workflowData.workflowId;
                newState.refinanceComplete = changeLoanRequest.refinanceComplete;
                newState.steps = newLoanStepperService(workflowData.workflowId);
                newState.currentStep = workflowData.currentStepperStep + 1;
                newState.canMoveBack = workflowData.canMoveBack;
                newState.canMoveForward = workflowData.canMoveForward;
                newState.currentUser = currentUser;
                newState.email = currentUser.claims.email;
                newState.requestedAmount = changeLoanRequest.requestedAmount;

                if (fundingInfo.FundDelivery === metadataService.fundDeliveryType.InStore) {
                    if (fundingInfo.BranchId) {
                        this.setState({ isWorking: true });
                        metadataService.getBranch(fundingInfo.BranchId)
                            .then(response => {
                                this.setState({ ...newState, isWorking: false, sunLoanBranch: response.data });
                            });

                    }
                }
                else {
                    newState.sunLoanBranch = fundingInfo.BranchId;
                    this.setState(newState);
                }

                this.handleChangeState(newState);
                await this.updateLoanAmounts(newState.state);
                this.validateForSubmit();
            }
        }
    }

    handleChangeState(newState) {
        // newState.formError=this.formHasError(newState);
        this.setState(newState)
    }

    handleCheckChange(e) {
        const { target } = e;
        const { name } = target

        this.setState({
            [name]: !this.state[name]
        });
    }

    handleNavigationToPersonalDataScreen = () => {
        //const { dispatch } = this.props;

        //dispatch(registrationActions.handleNavigationToPersonalDataScreen());
    }

    handleNavigationToIDScreen = () => {
        //const { dispatch } = this.props;

        //dispatch(registrationActions.handleNavigationToIDScreen());
    }

    handleNavigationToPasswordScreen = () => {
        //const { dispatch } = this.props;

        //dispatch(registrationActions.handleNavigationToPasswordScreen());
    }

    handleSubmit = async () => {
        // const { dispatch } = this.props;
        this.setState({ submitting: true });
        const { workflowId } = this.state;
        if (workflowId === workflowConstants.REFINANCE_INCREASE_LOAN_WORKFLOW
            || workflowId === workflowConstants.REFINANCE_INCREASE_LOAN_DISABLED_FUNDING_WORKFLOW) {
            const changeLoanRequest = JSON.parse(sessionStorage.getItem("changeLoanRequest"));
            const changeLoanRequestPayload = {
                currentLoanId: changeLoanRequest.currentLoanId,
                requestType: changeLoanRequest.requestType,
                LeadType: this.state.requestType === '1' ? 7 : 8,
                requestedAmount: changeLoanRequest.requestedAmount,
                ...this.createNewLoanRequest(),
            }
            this.props.actions.submitChangeLoanRequest(changeLoanRequestPayload);
        } else {
            let newLoanRequest = this.createNewLoanRequest();

            let hashMatch = await newLoanActions.checkForUserHash(newLoanRequest.userHash);

            if (hashMatch) {
                newLoanActions.sendNotificationEmail(newLoanRequest.Email, newLoanRequest.userHash, userService.getUserLanguage());
                //hash is in use - transfer to login
                this.props.actions.sendToLoginHashInUse();
                return;
            }

            let workflowData = workflowService.getCurrentWorkflowStepData();

            if (workflowData.workflowId === workflowConstants.NEW_LOAN_LANDING_PAGE_WORKFLOW) {
                this.props.actions.newLoanAppByLeadId(newLoanRequest);
            }
            else {
                this.props.actions.newLoanApp(newLoanRequest);
            }
        }
    }

    handleEditDetails = (section) => {
        const { workflowId } = this.state;

        // todo: if refinance workflow, add a refi=true query to cover button logic.
        //let pathSearch = workFlowList.workflow.find(x => x.path.includes(section) ? x.path : null);
        let searchString = workflowId === workflowConstants.REFINANCE_INCREASE_LOAN_DISABLED_FUNDING_WORKFLOW ||
            workflowId === workflowConstants.REFINANCE_INCREASE_LOAN_DISABLED_FUNDING_WORKFLOW ? 'edit=true&refi=true' : 'edit=true';
        let path = (workflowId === workflowConstants.REFINANCE_INCREASE_LOAN_DISABLED_FUNDING_WORKFLOW ||
            workflowId === workflowConstants.REFINANCE_INCREASE_LOAN_DISABLED_FUNDING_WORKFLOW ? "/Refinance" : "") + section;

        history.push({ pathname: path, search: searchString })
    }

    handleEditRequestedAmount = () => {
        const { isEditingRequesedAmount, workflowId } = this.state;
        if (isEditingRequesedAmount === true) {
            return;
        } else if (workflowId === workflowConstants.REFINANCE_INCREASE_LOAN_DISABLED_FUNDING_WORKFLOW ||
            workflowId === workflowConstants.REFINANCE_INCREASE_LOAN_DISABLED_FUNDING_WORKFLOW) {
            this.handleEditDetails("/SelectLoan");
        } else {
            this.setState({ tempRequestedAmount: this.state.requestedAmount, isEditingRequesedAmount: true });
        }
    }

    handleEditRequestAmountChange = ({ target: { name, value } }) => {
        this.setState({ tempRequestedAmount: value, isAmountValid: this.isValidAmountValue(value) });
    }

    handleEditRequestAmountSet = () => {
        if (this.state.tempRequestedAmount && validator.isNumeric(this.state.tempRequestedAmount + '')) {
            this.setState({ requestedAmount: this.state.tempRequestedAmount, isEditingRequesedAmount: false })
        }
    }

    handleEditRequestAmountCancel = () => {
        this.setState({ isEditingRequesedAmount: false });
    }

    validateForSubmit() {
        let isValid = false;
        const isValidFinancials = this.isValidFinancials();
        const isValidFunding = this.isValidFunding();
        const isValidPersonalInfo = this.isValidPersonalInfo();
        const isValidAmount = this.isValidAmount();

        isValid = (this.state.verifyContact === true
            && isValidFinancials
            && isValidFunding
            && isValidPersonalInfo
            && isValidAmount);
        this.setState({
            isInvalid: !isValid, errorMessages: [
                isValidFinancials !== true && "MyIncome",
                isValidAmount !== true && "RequestedAmount",
                isValidPersonalInfo !== true && "SectionMyInfo",
                isValidFunding !== true && "Funding",
            ].filter(Boolean)
        });
    }


    createNewLoanRequest() {
        
        // TODO: Gather all the info we have recorded since the start and place it in the object below, as payload for the api
        let registrationPersonalInfo = SessionService.getPersonalInfo();
        //let financialInformation = SessionService.getFinancialInfo();        
        let fundingInfo = SessionService.getFundingInformation();

        let leadId = this.props.leadId;
        let email = registrationPersonalInfo ? registrationPersonalInfo.email : sessionStorage.getItem("email");

        let workflowData = workflowService.getCurrentWorkflowStepData();

        const newLoanRequestModel = newLoanService.getNewLoanRequestModel(workflowData.workflowId);

        if (workflowData.workflowId === workflowConstants.NEW_LOAN_LANDING_PAGE_WORKFLOW) {
            return {
                ...newLoanRequestModel,
                LeadId: leadId,
                RequestedAmount: this.state.requestedAmount,
                userLanguage: userService.getUserLanguage(),
                Offers: this.state.verifyOffers,
                Confirm: this.state.verifyConfirm,
                Contact: this.state.verifyContact,
                disclosureVersion: this.props.disclosure.version,
                disclosureSoftHit: this.props.disclosure.softHit,
                preApprovalOffer: this.props.preApprovalOffer,
                ...this.state.marketingCookies
            }
        } else {
            return {
                ...newLoanRequestModel,
                requestedAmount: this.state.requestedAmount,
                userLanguage: userService.getUserLanguage(),
                Offers: this.state.verifyOffers,
                Confirm: this.state.verifyConfirm,
                Contact: this.state.verifyContact,
                DisclosureVersion: this.props.disclosure.version,
                DisclosureSoftHit: this.props.disclosure.softHit,
                preApprovalOffer: this.props.preApprovalOffer,
                ...this.state.marketingCookies
            };
        }
    }

    onDone() {
        // navigate to homepage here, for refinance workflow
        if (this.state.workflowId === workflowConstants.REFINANCE_INCREASE_LOAN_WORKFLOW
            || this.state.workflowId === workflowConstants.REFINANCE_INCREASE_LOAN_DISABLED_FUNDING_WORKFLOW) {
            sessionStorage.removeItem("changeLoanRequest");
            sessionStorage.removeItem("workFlowData");
            history.push("/");
        }
        else {
            sessionStorage.removeItem("workFlowData");
        }
    }

    generateConsentString() {
        const { userState } = this.state;
        const lang = userService.getUserLanguage().toLowerCase();
        const verifyConsent = lang === "es" ? this.props.disclosure.spanishText : this.props.disclosure.englishText;
        let SMSUrl = lang === "es" ? this.state.SMSUrlSpanish : this.state.SMSUrl;
        return userState === "AL" ?
            <div>
                <span className={"sl-red font-size-18"}>{" * "}</span>
                <div>
                    {metadataService.getMessage("ByCheckingThisBox")}
                </div>
                <br />
                <div>
                    <div><b>{metadataService.getLabel("BySubmitting")}</b> {metadataService.getLabel("VerifyAge19")}</div>
                    <br />
                    <div>{metadataService.getLabel("VerifyConfirm")}</div>
                    <br />
                    <div>{verifyConsent}</div>
                    <br />
                </div>
            </div>
            :
            <div>

                <div className="disclosure-agreement text-muted" ><div>
                    {metadataService.getMessage("ByCheckingThisBox")}&nbsp;
                    <a target="_blank" href={SMSUrl}>{metadataService.getMessage("ByCheckingThisBox2")} </a>
                    {metadataService.getMessage("ByCheckingThisBox3")}
                </div>
                    <br /><b>{metadataService.getLabel("BySubmitting")}</b> {metadataService.getLabel("VerifyAge") + " " + metadataService.getLabel("VerifyConfirm") + " " + verifyConsent}</div>
            </div>
    }

    generateContactString() {
        return (
            <div>
                <span className={"sl-red font-size-18"}>{" * "}</span>
                <span className={"font-weight-bold font-size-16"}>{metadataService.getLabel("Required") + " "}</span>
                <div>
                    {metadataService.getLabel("ContactBy")}
                </div>
            </div>
        )
    }
    isValidPersonalInfo() {
        const {
            firstName,
            lastName,
            email,
            address1,
            city,
            state,
            postalCode,
            years,
            months,
            residenceType
        } = this.state;
        return !metadataService.isNullOrEmpty(firstName)
            && !metadataService.isNullOrEmpty(lastName)
            && !metadataService.isNullOrEmpty(email)
            && !metadataService.isNullOrEmpty(address1)
            && !metadataService.isNullOrEmpty(city)
            && !metadataService.isNullOrEmpty(state)
            && !metadataService.isNullOrEmpty(postalCode)
            && (!metadataService.isNullOrEmpty(years) || !metadataService.isNullOrEmpty(months))
            && !metadataService.isNullOrEmpty(residenceType)
    }
    isValidFinancials() {
        const { employers, incomes } = this.props;
        if (metadataService.isNullOrEmpty(employers) && metadataService.isNullOrEmpty(incomes)) {
            return false;
        }
        if (!metadataService.isNullOrEmpty(employers)) {
            [...employers].forEach(employer => {
                const {
                    employerName,
                    incomePerPeriod,
                    payFrequency,
                    years,
                    months,
                } = employer;
                if (metadataService.isNullOrEmpty(employerName)
                    || metadataService.isNullOrEmpty(incomePerPeriod)
                    || metadataService.isNullOrEmpty(payFrequency)
                    || metadataService.isNullOrEmpty(years)
                    || metadataService.isNullOrEmpty(months)) {
                    return false;
                };
            });
        }
        if (!metadataService.isNullOrEmpty(incomes)) {
            [...incomes].forEach(income => {
                const {
                    otherIncomeSource,
                    amount,
                } = income;
                if (metadataService.isNullOrEmpty(otherIncomeSource)
                    || metadataService.isNullOrEmpty(amount)) {
                    return false;
                };
            });
        }
        return true;
    }
    isValidFunding() {
        const { fundDelivery, sunLoanBranch, workflowId } = this.state;
        if (workflowId === workflowConstants.NEW_LOAN_LANDING_PAGE_WORKFLOW) return true;
        return !metadataService.isNullOrEmpty(fundDelivery) && !metadataService.isNullOrEmpty(sunLoanBranch);
    }
    isValidAmount() {
        const { requestedAmount, workflowId } = this.state;
        return (workflowId === workflowConstants.REFINANCE_INCREASE_LOAN_DISABLED_FUNDING_WORKFLOW ||
            workflowId === workflowConstants.REFINANCE_INCREASE_LOAN_DISABLED_FUNDING_WORKFLOW) || this.isValidAmountValue(requestedAmount);
    }
    isValidAmountValue(amount) {
        const { minLoanAmount, maxLoanAmount } = this.state;
        if (metadataService.isNullOrEmpty(amount)) {
            return false;
        } else if (!metadataService.isNullOrEmpty(minLoanAmount) && !metadataService.isNullOrEmpty(maxLoanAmount)) {
            return (Number(minLoanAmount) <= Number(amount))
                && (Number(maxLoanAmount) >= Number(amount))
        } else {
            return true;
        }
    }
    updateLoanAmounts = async (state) => {
        if (metadataService.isNullOrEmpty(state)) {
            this.setState({
                minLoanAmount: null,
                maxLoanAmount: null
            });
        }
        else {
            try {
                this.setState({ isWorking: true });
                const stateValidation = await newLoanService.validateState(state);
                let { doesBusinessInState, minLoanAmount, maxLoanAmount } = stateValidation.data;
                if (!doesBusinessInState) {
                    minLoanAmount = null;
                    maxLoanAmount = null;
                }
                this.setState({
                    minLoanAmount: minLoanAmount,
                    maxLoanAmount: maxLoanAmount
                });
            } catch (error) {
                this.setState({
                    minLoanAmount: null,
                    maxLoanAmount: null
                });
            } finally {
                this.setState({ isWorking: false });
            }
        }
    }
    render() {
        const { firstName, lastName, email, mobileNumber, address, city, userState, zipCode, language,
            dateOfBirth, idNumber, isIDConsular, isIDSSN, address2, employers,
            incomes, branch, preApprovalOffer } = this.props;
        const { workflowId, maxLoanAmount, minLoanAmount } = this.state;
        return (
            <div>
                {this.state.refinanceComplete ? (
                    <div>
                        <ConfirmationView
                            sunLoanBranchId={this.state.sunLoanBranch}
                            onDone={this.onDone}
                        />
                    </div>
                ) : (
                    <div className="p-3">
                        <Stepper
                            stepData={this.props.steps}
                            currentStep={this.props.currentStep}
                        />

                        <SlPageTitle pageName="ConfirmationSummary" />

                        <Row>
                            <Col>
                                <SlSectionLabel
                                    sectionName={preApprovalOffer ? "PreApprovalAmount" : "RequestedAmount"}
                                    className={`my-2${metadataService.isNullOrEmpty(
                                        this.state.requestedAmount
                                    )
                                        ? " text-danger"
                                        : ""
                                        }`}
                                >
                                    *
                                </SlSectionLabel>
                            </Col>
                            <Col>
                                {this.state.isEditingRequesedAmount === false && (
                                    <div>
                                        <span
                                            className={
                                                "confirmation-summary-requested-amount" +
                                                (!this.state.hideEditButtons
                                                    ? " cursor-pointer"
                                                    : "")
                                            }
                                            onClick={(e) => {
                                                if (!this.state.hideEditButtons && !preApprovalOffer)
                                                    this.handleEditRequestedAmount();
                                                else e.preventDefault();
                                            }}
                                            title={
                                                !this.state.hideEditButtons && !preApprovalOffer
                                                    ? metadataService.getButton("ClickToEdit")
                                                    : ""
                                            }
                                        >
                                            {metadataService.formatMoney(
                                                this.state.requestedAmount
                                            )}
                                        </span>
                                        {!this.state.hideEditButtons && !preApprovalOffer && (
                                            <small
                                                className="cursor-pointer"
                                                title={metadataService.getButton("ClickToEdit")}
                                                onClick={this.handleEditRequestedAmount}
                                            >
                                                <img style={{ width: "1.5rem" }} src={pencil} />
                                            </small>
                                        )}
                                    </div>
                                )}
                                {this.state.isEditingRequesedAmount === true && (
                                    <Row>
                                        <Col sm={12} md={8}>
                                            <span>
                                                <SlMoneyInput
                                                    name="RequestedAmount"
                                                    value={this.state.tempRequestedAmount}
                                                    fieldErrors={this.state.fieldErrors}
                                                    onChange={this.handleEditRequestAmountChange}
                                                    required={true}
                                                    placeholder="$"
                                                    showLabel={false}
                                                    minAmount={minLoanAmount}
                                                    maxAmount={maxLoanAmount}
                                                />
                                            </span>
                                        </Col>
                                    </Row>
                                )}
                            </Col>
                        </Row>

                        {this.state.isEditingRequesedAmount === true && (
                            <Row className="justify-content-center">
                                <Col sm={12} md={8}>
                                    <span className="px-2">
                                        <SlButton
                                            name="OK"
                                            onClick={this.handleEditRequestAmountSet}
                                            disabled={this.state.isAmountValid === false}
                                        />
                                    </span>
                                    <span className="px-2">
                                        <SlButton
                                            name="Cancel"
                                            cssClass="backBtn"
                                            onClick={this.handleEditRequestAmountCancel}
                                        />
                                    </span>
                                </Col>
                            </Row>
                        )}

                        <SlSectionTitle
                            sectionName="SectionMyInfo"
                            className="mt-3 mb-0"
                        />
                        {!this.state.hideEditButtons && (
                            <Row className="justify-content-center p-0 mt-0">
                                <Col xs={12} md={8} className="text-right">
                                    <small
                                        className="cursor-pointer"
                                        title={metadataService.getButton("ClickToEdit")}
                                        onClick={() => this.handleEditDetails("/PersonalInfo")}
                                    >
                                        <img style={{ width: "1.5rem" }} src={pencil} />
                                    </small>
                                </Col>
                            </Row>
                        )}
                        <Row className="justify-content-center mb-3 pb-0">
                            <Col xs={12} md={8}>
                                <SLDetailsTable
                                    dataSource={[
                                        {
                                            label: metadataService.getFieldNameLabel("FirstName"),
                                            value: this.state.firstName,
                                            required: true,
                                            hasError: metadataService.isNullOrEmpty(
                                                this.state.firstName
                                            ),
                                        },
                                        {
                                            label: metadataService.getFieldNameLabel("LastName"),
                                            value: this.state.lastName,
                                            required: true,
                                            hasError: metadataService.isNullOrEmpty(
                                                this.state.lastName
                                            ),
                                        },
                                        {
                                            label: metadataService.getFieldNameLabel("Email"),
                                            value: this.state.email,
                                            required: true,
                                            hasError: metadataService.isNullOrEmpty(
                                                this.state.email
                                            ),
                                        },
                                        !metadataService.isNullOrEmpty(
                                            this.state.mobileNumber
                                        ) && {
                                            label:
                                                metadataService.getFieldNameLabel("MobileNumber"),
                                            value: metadataService.formatPhoneNumber(
                                                this.state.mobileNumber
                                            ),
                                        },
                                        !metadataService.isNullOrEmpty(
                                            this.state.alternateMobileNumber
                                        ) && {
                                            label: metadataService.getFieldNameLabel(
                                                "AlternateMobileNumber"
                                            ),
                                            value: metadataService.formatPhoneNumber(
                                                this.state.alternateMobileNumber
                                            ),
                                        },
                                        {
                                            label: metadataService.getFieldNameLabel("Address"),
                                            value: this.state.address1,
                                            required: true,
                                            hasError: metadataService.isNullOrEmpty(
                                                this.state.address1
                                            ),
                                        },
                                        {
                                            label: metadataService.getFieldNameLabel("City"),
                                            value: this.state.city,
                                            required: true,
                                            hasError: metadataService.isNullOrEmpty(
                                                this.state.city
                                            ),
                                        },
                                        {
                                            label: metadataService.getFieldNameLabel("State"),
                                            value: this.state.state,
                                            required: true,
                                            hasError: metadataService.isNullOrEmpty(
                                                this.state.state
                                            ),
                                        },
                                        {
                                            label: metadataService.getFieldNameLabel("ZipCode"),
                                            value: this.state.postalCode,
                                            required: true,
                                            hasError: metadataService.isNullOrEmpty(
                                                this.state.postalCode
                                            ),
                                        },
                                        {
                                            label: metadataService.getFieldNameLabel("Language"),
                                            value: metadataService.getLookupText(
                                                "language",
                                                userService.getUserLanguage().toLowerCase()
                                            ),
                                        },
                                        {
                                            label:
                                                metadataService.getFieldNameLabel(
                                                    "TimeInResidence"
                                                ),
                                            value:
                                                !metadataService.isNullOrEmpty(this.state.years) ||
                                                    !metadataService.isNullOrEmpty(this.state.months)
                                                    ? `${this.state.years == "" ? "0" : this.state.years} ${metadataService.getLabel(
                                                        "Years"
                                                    )} ${this.state.months == "" ? "0" : this.state.months} ${metadataService.getLabel("Months")}`
                                                    : "",
                                            required: true,
                                            hasError:
                                                metadataService.isNullOrEmpty(this.state.years) &&
                                                metadataService.isNullOrEmpty(this.state.months),
                                        },
                                        {
                                            label:
                                                metadataService.getFieldNameLabel("ResidenceType"),
                                            value: !metadataService.isNullOrEmpty(
                                                this.state.residenceType
                                            )
                                                ? metadataService.getLookupText(
                                                    "residenceType",
                                                    this.state.residenceType
                                                )
                                                : "",
                                            required: true,
                                            hasError: metadataService.isNullOrEmpty(
                                                this.state.residenceType
                                            ),
                                        },
                                        (workflowId !== workflowConstants.NEW_LOAN_LANDING_PAGE_WORKFLOW && {
                                            label: metadataService.getFieldNameLabel(
                                                "MonthlyResidencePayment"
                                            ),
                                            value: !metadataService.isNullOrEmpty(
                                                this.state.monthlyResidencePayment
                                            )
                                                ? metadataService.formatMoney(
                                                    this.state.monthlyResidencePayment
                                                )
                                                : "",
                                            required: true,
                                            hasError: metadataService.isNullOrEmpty(
                                                this.state.monthlyResidencePayment
                                            ),
                                        }),
                                    ]}
                                    bordered={true}
                                    striped={true}
                                />
                            </Col>
                        </Row>

                        <Row className="justify-content-center mb-3 pb-0">
                            <Col xs={12} md={8}>
                                <FinancialDetails
                                    employers={employers}
                                    incomes={incomes}
                                    showEdit={!this.state.hideEditButtons}
                                    onEdit={() => this.handleEditDetails("/FinancialInfo")}
                                />
                            </Col>
                        </Row>
                        {workflowId !== workflowConstants.NEW_LOAN_LANDING_PAGE_WORKFLOW &&
                            <SlSectionTitle
                                sectionName="Funding"
                                className="mt-3 mb-0"
                            ></SlSectionTitle>
                        }

                        {workflowId !== workflowConstants.NEW_LOAN_LANDING_PAGE_WORKFLOW &&
                            <React.Fragment>
                                {!this.state.hideEditButtons &&
                                    workflowId !==
                                    workflowConstants.REFINANCE_INCREASE_LOAN_DISABLED_FUNDING_WORKFLOW && (
                                        <Row className="justify-content-center p-0 mt-0">
                                            <Col xs={12} md={8} className="text-right">
                                                <small
                                                    className="cursor-pointer"
                                                    title={metadataService.getButton("ClickToEdit")}
                                                    onClick={() =>
                                                        this.handleEditDetails("/FundingSelection")
                                                    }
                                                >
                                                    <img style={{ width: "1.5rem" }} src={pencil} />
                                                </small>
                                            </Col>
                                        </Row>
                                    )}
                                <Row className="justify-content-center mb-0 pb-0">
                                    <Col xs={12} md={8}>
                                        <SLDetailsTable
                                            dataSource={[
                                                {
                                                    label:
                                                        metadataService.getFieldNameLabel("FundSelection"),
                                                    value:
                                                        this.state.fundDelivery ===
                                                            metadataService.fundDeliveryType.Electronic
                                                            ? metadataService.getLabel("ElectronicDelivery")
                                                            : metadataService.getLabel("InStorePickup"),
                                                },
                                                !this.state.isWorking &&
                                                this.state.fundDelivery ===
                                                metadataService.fundDeliveryType.InStore && {
                                                    label:
                                                        metadataService.getFieldNameLabel("BranchId"),
                                                    value: !metadataService.isNullOrEmpty(
                                                        this.state.sunLoanBranch
                                                    ) ? (
                                                        <SlBranchDisplay
                                                            sunLoanBranch={this.state.sunLoanBranch}
                                                        />
                                                    ) : (
                                                        ""
                                                    ),
                                                    required: true,
                                                    hasError: metadataService.isNullOrEmpty(
                                                        this.state.sunLoanBranch
                                                    ),
                                                },
                                                !this.state.isWorking &&
                                                this.state.fundDelivery ===
                                                metadataService.fundDeliveryType.Electronic &&
                                                this.state.bankAccountNumber != null &&
                                                Number(this.state.bankAccountNumber) !== 0 && {
                                                    label:
                                                        metadataService.getFieldNameLabel(
                                                            "AccountNumber"
                                                        ),
                                                    value: metadataService.maskLastFourCharacters(
                                                        this.state.bankAccountNumber
                                                    ),
                                                },
                                                !this.state.isWorking &&
                                                this.state.fundDelivery ===
                                                metadataService.fundDeliveryType.Electronic &&
                                                this.state.bankRoutingNumber != null &&
                                                Number(this.state.bankRoutingNumber) !== 0 && {
                                                    label:
                                                        metadataService.getFieldNameLabel(
                                                            "RoutingNumber"
                                                        ),
                                                    value: metadataService.maskLastFourCharacters(
                                                        this.state.bankRoutingNumber
                                                    ),
                                                },
                                            ]}
                                            bordered={true}
                                            striped={true}
                                        />
                                    </Col>
                                </Row>
                            </React.Fragment>
                        }
                        <SlSectionLabel
                            sectionName="VerifyApplication"
                            centered={true}
                            className="mb-0"
                        />
                        <Row className="justify-content-center mb-0 pb-0">
                            <Col xs={12} md={8}>
                                <Card className="p-0 m-0">
                                    <CardBody>
                                        <span style={{ display: "flex", fontSize: "smaller", alignItems: "center" }}>
                                            <SlCheckBox
                                                fieldName={"verifyOffers"}
                                                isSelected={this.state.verifyOffers}
                                                onChange={this.handleCheckChange}
                                                value={this.state.verifyOffers}
                                            />
                                            <span style={{ color: "#247de7" }}>
                                                {metadataService.getLabel("Optional")}:
                                            </span>&nbsp;
                                            <b>
                                                {metadataService.getLabel("VerifyOffers")}
                                            </b>
                                        </span>
                                        {this.generateConsentString()}
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <SlFormEntryRow>
                            <div className="text-center">
                                <SlButton
                                    name={this.state.submitting ? "Processing" : "SubmitApp"}
                                    onClick={this.handleSubmit}
                                    disabled={
                                        this.state.isInvalid ||
                                        this.state.submitting ||
                                        this.state.isEditingRequesedAmount
                                    }
                                />
                                {this.state.isInvalid &&
                                    this.state.errorMessages.length > 0 && (
                                        <p className="text-center text-muted mt-3">
                                            <small className="text-danger">
                                                {metadataService.getMessage(
                                                    "ReviewFollowingSections"
                                                )}
                                                {this.state.errorMessages.map((err, i) =>
                                                    i === 0 ? (
                                                        <span className="p-0 m-0">
                                                            {" "}
                                                            {metadataService.getTitle(err)}
                                                        </span>
                                                    ) : (
                                                        <span className="p-0 m-0">
                                                            {", "}
                                                            {metadataService.getTitle(err)}
                                                        </span>
                                                    )
                                                )}
                                            </small>
                                        </p>
                                    )}
                            </div>
                        </SlFormEntryRow>
                    </div>
                )}
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { loggedIn } = state.authentication;
    const { existingCustomer, error, firstName, lastName, email, confirmEmail, mobileNumber, address, address2, city, userState, zipCode, language,
        dateOfBirth, idNumber, isIDConsular, isIDSSN, userHash, completedSteps, postingData, marketingCookies } = state.registration;

    const { bankingAccountNumber, bankRoutingNumber, refinanceLoading, leadId, preApprovalOffer } = state.newLoan;
    const {
        employers,
        incomes,
        branchId
    } = state.financialInfo;
    const { steps, currentStep, disclosure } = state.users;


    return {
        loggedIn, existingCustomer, error, firstName, lastName, email, confirmEmail, mobileNumber, address, address2, city, userState, zipCode, language,
        dateOfBirth, idNumber, isIDConsular, isIDSSN, userHash, completedSteps, postingData, marketingCookies, bankingAccountNumber, bankRoutingNumber, refinanceLoading, preApprovalOffer,
        steps, currentStep,
        employers, incomes, branchId, disclosure, leadId
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        actions: {
            submitChangeLoanRequest: (data) => {
                dispatch(refinanceIncreaseLoanActions.submitChangeLoanRequest(data));
            },
            newLoanApp: (data) => {
                dispatch(newLoanActions.newLoanApp(data));
            },
            newLoanAppByLeadId: (data) => {
                dispatch(newLoanActions.newLoanAppByLeadId(data));
            },
            sendToLoginHashInUse: () => {
                dispatch(newLoanActions.sendToLoginHashInUse());
            },
            loadFinancialsFromSession: () => {
                dispatch(financialInfoActions.loadFinancialsFromSession());
            }

        },
        unexpectedError: () => {
            dispatch(newLoanActions.unexpectedError(metadataService.getMessage("AnUnexpectedErrorHasOcurred")));
        }
    }
}


ConfirmationSummary.propTypes = {
    refinance: PropTypes.bool,
    refinanceData: PropTypes.object
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationSummary)


// WEBPACK FOOTER //
// ./src/components/subcomponents/ConfirmationSummary.js